export class DenyRequest {
    solicitud: Number;
    consecutivos: String[];
    justificacion: String;
}
